module.exports = __webpack_public_path__ + "static/img/sg_btn1.32429dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/sg_btn1.png
// module id = cSIb
// module chunks = 7